import { formatPrice } from '@/utils/formatPrice';

export const interpolateTemplate = (message: string, values: Record<string, string>) =>
	message.replace(/{{(formatPrice\((.*?)\)|.*?)}}/g, (match, p1, p2) => {
		if (p1.startsWith('formatPrice(')) {
			const key = p2.trim();
			return formatPrice('es-MX', 'MXN', values[key]);
		}
		return values[p1] || match;
	});
